export default __webpack_public_path__ + "comment-black-oval-bubble-shape.png";